import Emitter from "./Emitter";
import {constants} from "../../constants";

export default class PauseGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    PRAGMATIC_PLAY_handler() {
        this.emitGame('{ "type": "Tilt" }');
    }

    F1X2_handler() {
        this.emitGame("autoplay-disable");
    }

    SLINGO_handler() {
        this.emitGame({ event: "playInterrupted" });
    }

    GREENTUBE_handler() {
        this.emitGame("AUTOPLAYOFF:");
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgsAutoSpinStop" }));
    }

    RELAX_handler() {
        this.emitGame({ rgMessage: "oprg_GamePause" });
    }

    PNG_handler() {
        this.emitGame({ messageType: "request", request: "stopAutoplay" });
    }

    NETE_BLUEOCEAN_handler() {
        this.gb.netEntExtendRef.call("pauseAutoplay", [], function() { }, function(e) { });
    }

    NETE_NETE_handler() {
        this.gb.netEntExtendRef.call("pauseAutoplay", [], function() { }, function(e) { });
    }

    NLC_NLC_handler() {
        if (this.gb.nlcExtendRef) {
            this.gb.nlcExtendRef.call("pause");
        } else {
            this.emitGame("pause");
        }
    }

    MGS_handler() {
        this.emitGame("StopGamePlay");
    }

    EDICT_handler() {
        this.emitGame("pauseAutoPlay");
    }

    RST_handler() {
        this.emitGame(JSON.stringify({"event": "playInterrupted"}))
    }

    NEXTGEN_handler() {
        if (typeof this.gb.gameIframe.contentWindow === "object" && Object.keys(this.gb.gameIframe.contentWindow).length > 0) {
            Object.values(this.gb.gameIframe.contentWindow).forEach((value,i) => {
                if (value === this.gb.eventSource) {
                    this.gb.gameIframe.contentWindow[i].postMessage({ id: "stopAutoplay"}, this.gb.eventOrigin);
                    logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} GAME`, { id: "stopAutoplay", });
                }
            })
        }
    }

    NYX_NEXTGEN_handler() {
        if (typeof this.gb.gameIframe.contentWindow === "object" && Object.keys(this.gb.gameIframe.contentWindow).length > 0) {
            Object.values(this.gb.gameIframe.contentWindow).forEach((value,i) => {
                if (value === this.gb.eventSource) {
                    this.gb.gameIframe.contentWindow[i].postMessage({ id: "stopAutoplay"}, this.gb.eventOrigin);
                    logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} GAME`, { id: "stopAutoplay", });
                }
            })
        }
    }

    THUNDER_handler() {
        this.emitGame({ eventid: "pausegame" });
    }

    BP_handler() {
        this.emitGame({ type:"stopAutoplay" });
    }

    NSOFT_handler(disableStatus) {
        this.settings.iframe.contentWindow.postMessage({ type: "bettingDisabled", content: { status: disableStatus } }, this.settings.nsoftBaseUrl);
    }

    DGC_handler() {
        this.gb.emitters.emit.game.customMsg(
        {
            method:'operator.autoplay.stop'
        }, this.gb.dgcOrigin)
    }

    EVOLUTION_handler() {
        if (this.gb.evolutionSource) {
            this.gb.evolutionSource.postMessage({
                command: "EVO:STOP_AUTOPLAY"
            }, "*")
        }
    }

    SH_handler() {
        this.emitGame({name: 'autoSpin', value: 'stop'})
    }

    BGS_handler() {
        this.emitGame({ event: "doGamePause"});
    }

    RGU_handler() {
        this.emitGame({ event: "doGamePause"});
    }

    RAW_handler() {
        this.emitGame({ event: "doGamePause"});
    }

    HB_handler() {
        this.emitGame({ event: "doGamePause"});
    }

    STK_handler() {
        if (gcw) {
            gcw.triggerThirdPartyEvent("PAUSE")
        }
    }

    WD_handler() {
        this.emitGame({method:"WGEAPI.game.stopAutoPlay"})
    }

    QS_handler() {
        this.emitGame({ rgMessage: "oprg_GamePause" });
    }

    SPRIBE_handler() {
        this.emitGame({cmd: "ifc.stop.autoplay"});
    }

    HI5_handler() {
        window.postMessage({cmd:"hi5_pause",value:true},"*");
    }

    HKS_handler() {
        this.emitGame({ actionType: "disableGame" });
    }

    SYN_handler() {
        this.emitGame({event: "p2g.gamePlayDisable"});
    }

    KAJ_handler() {
        this.emitGame({'method': 'gel.autoPlay.stop'});
    }

    ISOFT_handler() {
        this.emitGame('STOP_AUTO_PLAY');
        this.emitGame('BLOCK_BETS');
    }

    PT_handler() {
        this.emitGame(JSON.stringify({
            "_type": "ucip.pause.g2wPauseNotification",
            "pause": true
        }))
        this.emitGame(JSON.stringify(
            {
                "_type": "ucip.pause.w2gPauseCommand",
                "pause": true}
        ))
    }

    YGG_handler() {
        this.emitGame({event:"game/pause"})
    }

    ZITRO_handler() {
        this.emitGame({ "name": "stopAutospins" });
    }

    HBN_handler() {
        this.emitGame({type: "pause", pause: true})
        this.emitGame({event: "playInterrupted"})
    }

    BFG_handler() {
        this.emitGame({ "bf:request_action": "pause" });
        this.emitGame({ "bf:request_action": "stop_autoplay" });
    }

    ENDOR_handler() {
        this.emitGame({ messageId: "blockGame" });
    }

    PLS_handler() {
        this.emitGame("StopAutoPlay")
    }

    SPN_handler() {
        this.emitGame({type: "pauseGame"})
    }

    HABANERO2_handler(){
        this.emitGame({type: "pause", pause: true, stopAuto: false})
    }

    PUSH_handler() {
        this.emitGame({
            method: 'disable'
        })
    }

    BOOMING_handler() {
        this.emitGame({
            event: 'pauseGame'
        })
    }

    _default() {
        // if (this.gb.walletProtocol && this.gb.walletProtocol === constants.PLAYTECH) {
        //         this.gb.playtechPause = true;
        //         var interval = setInterval(() => {
        //             if (!this.gb.isSpinning) {
        //                 this.emitGame({ wpgaction: "doGamePause" });
        //
        //                 if (this.gb.gameProviderCode === 'GAM' && this.gb.ptResFeat && this.gb.ptResFeat.includes('displaystatus')) {
        //                     this.gb.emitters.emit.web.customMsg(JSON.stringify({
        //                         "_type": "ucip.displaystatus.g2wUiStateNotification",
        //                         "busy": true
        //                     }))
        //                 }
        //
        //                 clearInterval(interval)
        //
        //                 return
        //             }
        //
        //         }, 10)
        // } else {
            this.emitGame({ wpgaction: "doGamePause" });
       //}
    }
}
